import './StatusBadge.css';

/**
 * Mockup parity for `.status` pills (ok / wait / bad).
 *   tone="ok" | "wait" | "bad" | "neutral"
 */
export function StatusBadge({ tone = 'neutral', children }) {
  return <span className={`ui-status-badge ui-status-badge--${tone}`}>{children}</span>;
}
